module.exports = __webpack_public_path__ + "static/media/triple-superior.3.84fa6df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/triple-superior/images/triple-superior.3.jpg
// module id = 699
// module chunks = 0